<template>
  <Component :is="typeof $route.meta.layout === 'function' ? $route.meta.layout() : $route.meta.layout">
    <RouterView />
  </Component>
  <HelpWidget />
  <PLoading />
  <ConfirmationModal />
  <PTooltip />
</template>

<script setup lang="ts">
import { PLoading } from '@pequity/squirrel';
import { defineAsyncComponent } from 'vue';
import ConfirmationModal from '@/components/confirmation-modal/confirmation-modal.vue';
import PTooltip from '@/components/p-tooltip/p-tooltip.vue';
import { useHelpStore } from '@/stores/help';

defineOptions({
  name: 'App',
});

// Data
const helpStore = useHelpStore();

// Async components
const HelpWidget = defineAsyncComponent(async () => {
  helpStore.loading = true;
  const helpWidget = await import('@/help/components/help-widget.vue');
  helpStore.loading = false;

  return helpWidget;
});
</script>
